module.exports = __webpack_public_path__ + "static/chaiNagari-38ccbfc58efc03b35971c5f3f418d5d3.jpg";